import { EventTypes, IReducerPayload, IUtilityReducer } from '../dataModels';
import { IReduxAction } from '@core-web/redux';

const initialState: IUtilityReducer = {
  filePaths: null,
};

export const Reducer = (
  state: IUtilityReducer = initialState,
  { type, payload }: IReduxAction<EventTypes, IReducerPayload>
): IUtilityReducer => {
  switch (type) {
    case EventTypes.FILEPATHS: {
      return { filePaths: payload?.filePaths || null };
    }
    default: {
      return state;
    }
  }
};
